import React, { useEffect } from 'react';

const WhatsappIntegration: React.FC = () => {
  useEffect(() => {
    // Extract the base path without the wsp_success part
    const currentPathname = window.location.pathname;
    console.log('Current pathname:', currentPathname);
    const integrationsPath = currentPathname.substring(0, currentPathname.lastIndexOf('/wsp_success'));
    
    // Create the target URL
    const targetUrl = new URL(integrationsPath, window.location.origin);
    targetUrl.searchParams.set('status', 'success');
    targetUrl.searchParams.set('service', 'WhatsApp');
    
    console.log('Redirecting to:', targetUrl.href);
    
    // Perform the redirect
    window.location.replace(targetUrl.href);
  });

  // This is just a fallback UI in case the redirect doesn't happen immediately
  return (
    <div>
      <h1>¡Integración con Whatsapp Exitosa!</h1>
      <p>
        Redirigiendo a la página de integraciones...
      </p>
    </div>
  );
};

export default WhatsappIntegration;
